import{css}from'glamor';export var root=css({margin:8});export var noResult=css({margin:16});